import React from "react";
import CustomAccordion from "../../utils/Accordion/CustomAccordion";
import UserInfo from "./UserInfo";
import GroupInfo from "./GroupInfo";
import InvestmentInfo from "./InvestmentInfo";
import "../../Assets/Styles/Style.css";
import Transactions from "./TransactionInfo";
const labelColors = ["#1f77b4", "#972D10", "#0F9F9F", "#106736"];
const InvestmentDataDisplay = ({ data }) => {
  const accordionSections = [
    {
      label: "User Info",
      content: <UserInfo data={data} />,
    },
    {
      label: "Group Info",
      content: <GroupInfo data={data} />,
    },
    {
      label: "Investment Info",
      content: <InvestmentInfo data={data} />,
    },
    {
      label: "Transactions",
      content: <Transactions data={data} />,
    },
  ];

  return (
    <div className="row">
      {accordionSections.map((section, index) => (
        <div key={index} className="col-md-3">
          <CustomAccordion
            sections={[
              {
                ...section,
                labelColor: labelColors[index % labelColors.length], // Cycle through colors
              },
            ]}
            height="260px"
          />
        </div>
      ))}
    </div>
  );
};

export default InvestmentDataDisplay;
